// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import {
    chain,
    DispatchCompleteUpdateShipTo,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateShipTo";

// XNG-Change validate shipto after selecting an address in order to display the address either in a form or as text
export const ValidateShippingAddress: typeof DispatchCompleteUpdateShipTo = async props => {
    const state = props.getState();
    const {
        context: { session },
    } = state;
    if (session.fulfillmentMethod === FulfillmentMethod.PickUp) {
        return;
    }

    let addressFieldsDataView = getAddressFieldsDataView(state);
    if (!addressFieldsDataView.value) {
        addressFieldsDataView = getAddressFieldsDataView(state);
    }

    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const shippingAddressErrors = await awaitableValidate({
        address: props.parameter.shipTo,
        validationRules: props.parameter.shipTo.validation!,
        addressFieldDisplayCollection: addressFieldsDataView.value!.shipToAddressFields,
    })(props.dispatch, props.getState);
    const isShippingAddressValid = Object.keys(shippingAddressErrors).length === 0;

    props.dispatch({
        type: "Pages/OnePageCheckout/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: !isShippingAddressValid,
    });
    props.dispatch({
        type: "Pages/OnePageCheckout/SetIsBillingAddressTheSameAsShipping",
        isBillingAddressTheSameAsShipping: false,
    });
};

addToChainAfter(chain, DispatchCompleteUpdateShipTo, ValidateShippingAddress);
